<template>
  <v-container
    class="px-1 py-1"
    fluid
  >
    <v-toolbar
      color="primary">
      <img src="../assets/background.svg"
           class="mt-4 mb-4"
           height="100%"
           alt="Logo"/>
      <v-toolbar-title
        class="headline white--text px-5"
      >
        {{ $t(translation + ".header") }}
      </v-toolbar-title>
    </v-toolbar>
    <v-row
      class="mt-3"
      justify="center"
      align="center"
    >
      <div
        class="headline white--text"
      >
        {{$t(translation + '.chooseRegistry')}}
      </div>
    </v-row>
    <v-row
      class="mt-3"
      justify="center"
      align="center"
    >
        <card v-for="page in this.pages"
              :key="page.to"
              :text="page.text"
              :to="page.to"
              :icon="page.icon"
              :is_link="page.is_link"
              class="primary mx-2"
              :has-round-corners="true"
              :has-box-shadow="true"
        />

    </v-row>
  </v-container>
</template>

<script>
import Card from '../components/portal/Cards'
import {readTableData} from "../statics/DataTableFunctions";

export default {
  components: {
    'card': Card,
  },
  data() {
    return {
      translation: 'public',
      pages: [
        {
          to: '/public/de_minimis',
          is_link: true,
          icon: 'mdi-view-agenda-outline',
          text: this.$t('help_registries.de_minimis.header'),
        },
        {
          to: '/public/covid',
          is_link: true,
          icon: 'mdi-virus-outline',
          text: this.$t('help_registries.covid.header'),
        },
        {
          to: '/public/general',
          is_link: true,
          icon: 'mdi-view-agenda',
          text: this.$t('help_registries.general.header'),
        },
        {
          to: '/public/returned',
          is_link: true,
          icon: 'mdi-recycle',
          text: this.$t('help_registries.returned.header'),
        },

      ],
    }
  },
  methods: {
    readTableData,
    getHeaderClass(name) {
      switch (name) {
        case "accepted":
          return 'green--text';
        case "inserted":
          return 'warning--text';
        case 'rejected':
          return 'error--text';
        default:
          return 'white--text'
      }
    },
    openPage(link) {
      EventBus.$emit('externalOpenLink', {
        link: link,
        openDrawer: false
      });
      this.$router.push(link)
    },
    readStats() {
      this.readTableData('help_registries/dashboard')
      // this.tableData = [
      //   {
      //     name: "De Minimis",
      //     accepted: 2,
      //     acceptedLink: '/help_registries/de_minimis/accepted',
      //     inserted: 1,
      //     insertedLink: '/help_registries/de_minimis/inserted',
      //     rejected: 0,
      //     rejectedLink: '/help_registries/de_minimis/returned',
      //   }
      // ];
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t(this.translation + '.name'),
          name: 'name',
          align: 'left',
          value: 'name'
        },
        {
          text: this.$t(this.translation + '.accepted'),
          name: 'accepted',
          align: 'right',
          value: 'accepted'
        },
        {
          text: this.$t(this.translation + '.inserted'),
          name: 'inserted',
          align: 'right',
          value: 'inserted'
        },
        {
          text: this.$t(this.translation + '.rejected'),
          name: 'rejected',
          align: 'right',
          value: 'rejected'
        }
      ];
    },
  },
  created() {
    if(this.$auth.isAuthenticated()) {
      this.$router.push('/dashboard');
    }
  }
}
</script>

<style>
.v-content__wrap {
  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url('../assets/pattern.jpg') repeat;
  background-size: contain;
}
</style>
